export const LAYERS_CREATED = 'layers-created';
export const LAYER_UPDATED = 'layer-updated';
export const CONFIG_LOADED = 'config-loaded';
export const MIN_ZOOM = 'min-zoom';
export const RESET_MIN_ZOOM = 'reset-min-zoom';
export const CONFIG_SAVED = 'config-saved';
export const CONFIG_RESET = 'config-reset';
export const CONFIG_UPDATED = 'config-updated';
